<template>
  <v-dialog v-model="dialog" max-width="1000px" persistent>
    <v-card>
      <v-card-title>
        <span class="title">{{ editingWuliuId ? 'Chỉnh sửa / 编辑' : 'Tạo mới / 新建' }} mã wuliu / 运单号</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex lg6 md6 sm12>
              <v-text-field
                v-model="formData.TransactionCode"
                label="Mã wuliu / 运单号 *"
                outlined
                dense
                required
              ></v-text-field>
            </v-flex>
            <v-flex lg6 md6 sm12>
              <!-- <v-text-field
                v-model="formData.ProductName"
                label="Tên hàng / 货名 *"
                outlined
                dense
                required
              ></v-text-field> -->
            </v-flex>
          </v-layout>
           <v-layout row wrap>
            <v-flex lg3 md3 sm6>
              <h-currency-input
                v-model="formData.TransactionDeposit"
                label="Phí ship nội địa / 国内运费 (¥)"
                :decimal="1"
              ></h-currency-input>
            </v-flex>
            <v-flex lg3 md3 sm6>
              <h-currency-input
                v-model="formData.PedicabDeposit"
                label="Phí xe lôi / 自提费 (¥)"
                :decimal="1"
              ></h-currency-input>
            </v-flex>
            <v-flex lg3 md3 sm6>
              <h-currency-input
                v-model="formData.LoadDeposit"
                label="Phí nâng hạ / 叉卸费 (¥)"
                :decimal="1"
              ></h-currency-input>
            </v-flex>
            <v-flex lg3 md3 sm6>
              <h-currency-input
                v-model="formData.ReinforceDeposit"
                label="Phí gia cố / 加固费 (¥)"
                :decimal="1"
              ></h-currency-input>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex lg3 md3 sm6>
              <h-currency-input
                v-model="formData.Weight"
                label="Cân nặng (kg) / 重量"
                :decimal="1"
              ></h-currency-input>
            </v-flex>
            <v-flex lg3 md3 sm6>
              <h-currency-input
                v-model="formData.Volume"
                label="Thể tích (m³) / 体积"
                :decimal="3"
                readonly
              ></h-currency-input>
            </v-flex>
            <v-flex lg3 md3 sm6>
              <h-currency-input
                v-model="formData.Qty"
                label="Số lượng / 数量"
                :decimal="0"
                readonly
              ></h-currency-input>
            </v-flex>
            <v-flex lg3 md3 sm6>
              <h-currency-input
                v-model="formData.Deposit"
                label="Tổng chi tệ / 总支出金额"
                :decimal="1"
                readonly
              ></h-currency-input>
            </v-flex>
          </v-layout>

          <v-divider class="my-4"></v-divider>

          <v-layout row wrap align-center class="mb-2">
            <v-flex lg6 md6 sm12>
              <h4>Danh sách kiện hàng / 货件列表</h4>
            </v-flex>
            <v-flex lg6 md6 sm12 class="text-right">
              <v-btn small color="primary" @click="addPackage">
                <v-icon small>add</v-icon> Thêm kiện / 添加货件
              </v-btn>
            </v-flex>
          </v-layout>

          <v-data-table
            :headers="package_header"
            :items="formData.packages"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td>{{ index + 1 }}</td>
                <td>
                  <v-text-field
                    v-model.number="item.Length"
                    type="number"
                    dense
                    hide-details
                    @input="recalculateTotals"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model.number="item.Width"
                    type="number"
                    dense
                    hide-details
                    @input="recalculateTotals"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model.number="item.Height"
                    type="number"
                    dense
                    hide-details
                    @input="recalculateTotals"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model.number="item.Qty"
                    type="number"
                    dense
                    hide-details
                    @input="recalculateTotals"
                  ></v-text-field>
                </td>
                <td class="text-right">{{ calculatePackageVolume(item) | currency('', 3) }}</td>
                <td class="text-center">
                  <v-icon small @click="removePackage(index)">delete</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1 white--text" @click="close">Đóng / 关闭</v-btn>
        <v-btn color="primary" @click="save">Lưu lại / 保存</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { sendSuccessNotice, sendErrorNotice } from "@/commons/utils";

export default {
  name: "WuliuDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    wuliuId: {
      type: Number,
      default: null
    },
    exchangeRate: {
      type: Number,
      default: null
    },
    initialData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      editingWuliuId: null,
      formData: {
        TransactionCode: '',
        ProductName: '',
        Weight: 0,
        Volume: 0,
        Qty: 0,
        Deposit: 0,
        TransactionDeposit: 0,
        PedicabDeposit: 0,
        LoadDeposit: 0,
        ReinforceDeposit: 0,
        packages: []
      },
      package_header: [
        { text: 'STT / 序号', value: 'index', width: '60px' },
        { text: 'Dài (cm) / 长', value: 'Length', width: '100px' },
        { text: 'Rộng (cm) / 宽', value: 'Width', width: '100px' },
        { text: 'Cao (cm) / 高', value: 'Height', width: '100px' },
        { text: 'Số kiện / 件数', value: 'Qty', width: '100px' },
        { text: 'Thể tích (m³) / 体积', value: 'Volume', align: 'end', width: '120px' },
        { text: '', value: '', align: 'center', width: '60px' },
      ]
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.loadData();
      }
    }
  },
  methods: {
    async loadData() {
      if (this.wuliuId) {
        // Edit mode - load from store
        try {
          const wuliuDetail = await this.$store.dispatch("wuliu/getDetail", this.wuliuId);
          
          // Parse packages from JSON
          let packages = [];
          const packagesField = wuliuDetail.Packages || wuliuDetail.packages;
          
          if (packagesField) {
            try {
              packages = typeof packagesField === 'string' 
                ? JSON.parse(packagesField) 
                : (Array.isArray(packagesField) ? packagesField : []);
            } catch (e) {
              console.error("Error parsing packages:", e);
              packages = [];
            }
          }
          
          // Ensure packages is always an array
          if (!Array.isArray(packages)) {
            packages = [];
          }
          
          this.editingWuliuId = this.wuliuId;
          this.formData = {
            TransactionCode: wuliuDetail.TransactionCode || '',
            ProductName: wuliuDetail.ProductName || '',
            Weight: wuliuDetail.Weight || 0,
            Volume: wuliuDetail.Volume || 0,
            Qty: wuliuDetail.Qty || 0,
            Deposit: wuliuDetail.Deposit || 0,
            TransactionDeposit: wuliuDetail.TransactionDeposit || 0,
            PedicabDeposit: wuliuDetail.PedicabDeposit || 0,
            LoadDeposit: wuliuDetail.LoadDeposit || 0,
            ReinforceDeposit: wuliuDetail.ReinforceDeposit || 0,
            packages: packages
          };
        } catch (err) {
          console.error("Error loading wuliu:", err);
          sendErrorNotice("Lỗi khi tải thông tin Wuliu: " + (err.message || err));
        }
      } else if (this.initialData) {
        // Create mode with initial data
        this.editingWuliuId = null;
        this.formData = { ...this.initialData };
      } else {
        // Create mode without initial data
        this.editingWuliuId = null;
        this.resetForm();
      }
    },
    resetForm() {
      this.formData = {
        TransactionCode: '',
        ProductName: '',
        Weight: 0,
        Volume: 0,
        Qty: 0,
        Deposit: 0,
        TransactionDeposit: 0,
        PedicabDeposit: 0,
        LoadDeposit: 0,
        ReinforceDeposit: 0,
        packages: []
      };
    },
    addPackage() {
      this.formData.packages.push({
        Length: 0,
        Width: 0,
        Height: 0,
        Qty: 1
      });
    },
    removePackage(index) {
      this.formData.packages.splice(index, 1);
      this.recalculateTotals();
    },
    calculatePackageVolume(pkg) {
      return (pkg.Length || 0) * (pkg.Width || 0) * (pkg.Height || 0) / 1000000;
    },
    recalculateTotals() {
      let totalVolume = 0;
      let totalQty = 0;
      
      this.formData.packages.forEach(pkg => {
        totalVolume += this.calculatePackageVolume(pkg) * (pkg.Qty || 1);
        totalQty += (pkg.Qty || 0);
      });
      this.formData.Volume = totalVolume;
      this.formData.Qty = totalQty;
    },
    close() {
      this.dialog = false;
      this.editingWuliuId = null;
      this.resetForm();
      this.$emit('close');
    },
    async save() {
      // Validate
      if (!this.formData.TransactionCode) {
        sendErrorNotice("Vui lòng nhập mã Wuliu");
        return;
      }
      //if (!this.formData.ProductName) {
      //  sendErrorNotice("Vui lòng nhập tên hàng");
      //  return;
      //}
      if (this.formData.packages.length === 0) {
        sendErrorNotice("Vui lòng thêm ít nhất một kiện hàng");
        return;
      }
      if (!this.exchangeRate == null && this.formData.Deposit > 0) {
        sendErrorNotice("Tỷ giá chưa được thiết lập. Vui lòng kiểm tra lại.");
        return;
      }
      
      this.$emit('save', {
        formData: this.formData,
        editingWuliuId: this.editingWuliuId
      });
    }
  }
};
</script>
